import {
  addProducts,
  addProductsSuccess,
  addProductsFail,
  createListByProp
} from '../Products/action'

const fetchUserRecomendation = client => () => {
  return (dispatch, _) => {
    dispatch(addProducts())

    client
      .get(`/v2/products/recommendations/participant?take=10`)
      .then(response => {
        const productsList = transformResponseData(response.data)

        dispatch(addProductsSuccess(productsList))

        dispatch({
          type: 'FETCH_USER_RECOMENDATION_SUCCESS',
          payload: {
            data: createListByProp(productsList, 'sku')
          }
        })
      })
      .catch(err => dispatch(addProductsFail(err)))
  }
}

const fetchItemToItemRecomendation = client => productId => {
  return (dispatch, _) => {
    dispatch(addProducts())

    client
      .get(`/v2/products/recommendations/product/${productId}?take=10`)
      .then(response => {
        const productsList = transformResponseData(response.data)

        dispatch(addProductsSuccess(productsList))

        dispatch({
          type: 'FETCH_ITEM_TO_ITEM__RECOMENDATION_SUCCESS',
          payload: {
            data: createListByProp(productsList, 'sku')
          }
        })
      })
      .catch(err => dispatch(addProductsFail(err)))
  }
}

const transformResponseData = response => {
  return response.map(item => ({
    sku: item.productSkuId,
    originalId: item.originalProductSkuId,
    imageUrl: item.imageUrl,
    name: item.name,
    productId: item.productId,
    vendorId: item.vendorId
  }))
}

export default client => ({
  fetchUserRecomendation: fetchUserRecomendation(client),
  fetchItemToItemRecomendation: fetchItemToItemRecomendation(client)
})



// WEBPACK FOOTER //
// ./src/features/Recomendation/actions.js